// NPM Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "../../revvComponents";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../revvComponents";

// Components Imports

// Actions Imports

// Internal Imports

// Destructuring

// Declarations

export default function MetaFieldViewHeader(props) {
  const mode = props.mode === "DOCUMENT" ? "Document" : "Template";
  return (
    <>
      <div className="meta-field-header-view">
        {/* <div className="meta-field-header">
          <div className="meta-field-header-text">
            METAFIELDS{" "}
            <span className="meta-fields-count">
              &nbsp;{metaFieldsCount || 0}
            </span>
          </div>
          <div className="meta-field-header-subtext">
            Subtext about metafields. Give some explanation.
          </div>
        </div> */}
        {/* <div>
          {" "} */}
        <Button
          type="three"
          className="create-metafield-btn"
          onClick={props.handleCreateMetaFieldBox}
          data-test="e-sign-btn">
          <FontAwesomeIcon icon={["fas", "plus-circle"]} />
          &nbsp; {`Create ${mode} Meta field`}
        </Button>
        {/* </div> */}
      </div>
    </>
  );
}
